import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/mobile-app/banner_mobile.webp";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  // Function to handle the scroll action
  const scrollToCaseStudies = () => {
    const caseBtnElement = document.getElementById("case_btn");
    if (caseBtnElement) {
      // Using `scrollIntoView` to scroll to the target element
      caseBtnElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div
      className="service_usa web_dev_service on_demand_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner">
                Mobile App Development Company USA
              </h1>
              <h1 style={{ marginBottom: "10px" }}>
                Snappy, Sleek Mobile Apps
              </h1>
              <p>
                We are a user-obsessed, value-driven mobile app development
                company. Every product we deploy reflects our built-to-win
                prowess across platforms – whether iOS or Android. From feasible
                MVPs to full-scale custom applications, access top-tier
                consultancy and production with our end-to-end mobile app
                development services.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Consult App Idea
              </Link>
              <button
                className="border_btn web_case_btn mt-2 mt-md-3 mt-xl-0"
                aria-label="TekRevol Contact"
                onClick={scrollToCaseStudies}
              >
                App Development Portfolio
              </button>
            </div>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center offset-lg-1"
          >
            <div className="mobile_app_img_services">
              <StaticImage
                src="../../images/services-usa/mobile-app/mobile_app_mob.webp"
                alt="mobile app development company"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={719}
                height={649}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
